
import React, { useState, useEffect } from 'react';

export default function TimedDisplay(props) {
        const [isVisible] = useState(true);

        useEffect(() => {
            setTimer(props.delay);
        }, );


        const setTimer = (delay) => {
            setTimeout(() => {
              // setIsVisible(false);
                props.callback();
            }, delay);
        };

        return (
            isVisible
                ? <>{props.children}</>
                : <span />
        );
    }
